<template>
  <div id="documentManagement">
    <el-card>
      <el-form :model="searchForm" ref="searchForm" label-position="top" @keyup.enter.native="handleSearch">
        <el-row>
          <el-col :xl="6" :lg="8" :md="12">
            <el-form-item label="Country:" prop="country">
              <el-select filterable clearable v-model="searchForm.country" placeholder="Please select">
                <el-option v-for="item in countryList" :key="item.value" :label="item.meaning" :value="item.value"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :xl="6" :lg="8" :md="12">
            <el-form-item label="Account Name:" prop="accountName">
              <el-input clearable v-model="searchForm.accountName" placeholder="Please input" />
            </el-form-item>
          </el-col>
          <el-col :xl="6" :lg="8" :md="12">
            <el-form-item label="Document Type:" prop="docType">
              <el-select clearable v-model="searchForm.docType" placeholder="Please select">
                <el-option v-for="item in docTypeList" :key="item.value" :label="item.label" :value="item.value"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :xl="6" :lg="8" :md="12">
            <el-form-item label="Uploaded By:" prop="uploadedBy">
              <el-select
                clearable
                filterable
                remote
                v-model="searchForm.uploadedBy"
                placeholder="Please input"
                :remote-method="filterUploadedBy"
              >
                <el-option v-for="item in uploadedBySearchList" :key="item.empCode" :label="item.userCode" :value="item.userAccount"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :xl="6" :lg="8" :md="12">
            <el-form-item label="Period:" prop="periodStartYear">
              <div style="display:flex;align-items:center;gap:4px;">
                <el-date-picker
                  v-model="searchForm.periodStartYear"
                  type="year"
                  placeholder="Year"
                  clearable
                  format="yyyy"
                  value-format="yyyy"
                  style="width:110px"
                >
                </el-date-picker>
                <el-select clearable v-model="searchForm.periodStartQuarter" placeholder="Quarter" style="width:100px">
                  <el-option v-for="item in quarterOptions" :key="item" :label="item" :value="item"></el-option>
                </el-select>
                <span style="color:#8C8C8C;">—</span>
                <el-date-picker
                  v-model="searchForm.periodEndYear"
                  type="year"
                  placeholder="Year"
                  clearable
                  format="yyyy"
                  value-format="yyyy"
                  style="width:110px"
                >
                </el-date-picker>
                <el-select clearable v-model="searchForm.periodEndQuarter" placeholder="Quarter" style="width:100px">
                  <el-option v-for="item in quarterOptions" :key="item" :label="item" :value="item"></el-option>
                </el-select>
              </div>
            </el-form-item>
          </el-col>
          <el-col :xl="6" :lg="8" :md="12">
            <el-form-item label="Upload Time:" prop="uploadTime">
              <el-date-picker
                v-model="searchForm.uploadTime"
                type="daterange"
                range-separator="-"
                start-placeholder="Start date"
                end-placeholder="End date"
                clearable
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :xl="6" :lg="8" :md="12">
            <el-form-item label="Account Service No. (GTS):" prop="gtsCode">
              <el-input clearable v-model="searchForm.gtsCode" placeholder="Please input" />
            </el-form-item>
          </el-col>
          <el-col :xl="6" :lg="16" :md="12" class="btn-col" style="text-align: right;">
            <el-button type="primary" size="small" @click="handleSearch()">Search</el-button>
            <el-button size="small" @click="handleReset()">Reset</el-button>
          </el-col>
        </el-row>
      </el-form>

      <el-table :data="tableData" border v-loading="tableLoading" style="width: 100%" tooltip-effect="dark" :header-cell-style="{background:'#F5F5F9'}" @sort-change="handleSortChange">
        <el-table-column prop="accountName" label="Account Name" align="left" min-width="180" fixed="left" :show-overflow-tooltip="true" sortable="custom">
          <template slot-scope="scope">
            <a style="color:blue;cursor:pointer;" @click="handleDetail(scope.row)">{{ scope.row.accountName }}</a>
          </template>
        </el-table-column>
        <el-table-column prop="country" label="Country" align="center" min-width="120" :show-overflow-tooltip="true" sortable="custom"></el-table-column>
        <el-table-column prop="docType" label="Document Type" align="left" min-width="170" :show-overflow-tooltip="true" sortable="custom"></el-table-column>
        <el-table-column prop="periodDisplay" label="Period" align="center" min-width="100" :show-overflow-tooltip="true" sortable="custom"></el-table-column>
        <el-table-column prop="uploadTime" label="Upload Time" align="center" min-width="130" :show-overflow-tooltip="true" sortable="custom">
          <template slot-scope="scope">
            {{ scope.row.uploadTime ? moment(scope.row.uploadTime).format('YYYY-MM-DD') : '' }}
          </template>
        </el-table-column>
        <el-table-column prop="uploadedBy" label="Uploaded By" align="left" min-width="130" :show-overflow-tooltip="true" sortable="custom"></el-table-column>
        <el-table-column prop="gtsCode" label="Account Service No. (GTS)" align="center" min-width="150" :show-overflow-tooltip="true" sortable="custom"></el-table-column>
        <el-table-column prop="fileName" label="Document Name" align="left" min-width="220" :show-overflow-tooltip="true" sortable="custom">
          <template slot-scope="scope">
            <a style="color:blue;cursor:pointer;" @click="handleDocDownload(scope.row)">{{ scope.row.fileName }}</a>
          </template>
        </el-table-column>
        <el-table-column prop="remark" label="Remark" align="left" min-width="200" :show-overflow-tooltip="true" sortable="custom"></el-table-column>
        <el-table-column prop="operation" label="Operation" align="center" min-width="100" fixed="right">
          <template slot-scope="scope">
            <el-button size="mini" type="primary" @click="handleDocModify(scope.row)">Modify</el-button>
          </template>
        </el-table-column>
      </el-table>

      <div class="pageDiv" v-if="totalCount && totalCount > 0">
        <el-pagination
          small
          layout="total, prev, pager, next, sizes, jumper"
          :page-sizes="[10, 20, 50, 100]"
          :current-page="currentPage"
          :page-size="pageSize"
          :total="totalCount"
          @size-change="changePageSize"
          @current-change="changePage"
        >
        </el-pagination>
      </div>
    </el-card>

    <!-- Modify Document Dialog -->
    <el-dialog
      title="Modify Document"
      width="825px"
      :visible.sync="modifyVisible"
      :close-on-click-modal="false"
      custom-class="modify-doc-dialog"
    >
      <!-- Account Info -->
      <div class="modify-doc-info">
        <div class="modify-doc-info-row">
          <div class="modify-doc-info-item">
            <span class="modify-doc-info-label">Country:</span>
            <span class="modify-doc-info-value">{{ modifyForm.country }}</span>
          </div>
        </div>
        <div class="modify-doc-info-row">
          <div class="modify-doc-info-item">
            <span class="modify-doc-info-label">Account Code:</span>
            <span class="modify-doc-info-value">{{ modifyForm.gtsCode }}</span>
          </div>
          <div class="modify-doc-info-item">
            <span class="modify-doc-info-label">Account Name:</span>
            <span class="modify-doc-info-value">{{ modifyForm.accountName }}</span>
          </div>
        </div>
      </div>

      <!-- Attachment Section -->
      <div class="modify-doc-attachment">
        <div class="modify-doc-att-header">
          <span class="modify-doc-att-name">{{ modifyForm.docType }}</span>
          <span class="modify-doc-att-colon">:</span>
        </div>
        <el-form ref="modifyForm" :model="modifyForm" :rules="modifyRules" label-width="88px" label-position="right" size="mini">
          <el-form-item label="Document" prop="fileId">
            <el-upload
              class="doc-upload-btn"
              action="#"
              :http-request="uploadFile"
              :show-file-list="false"
              :before-upload="beforeUpload"
              accept=".pdf,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.jpg,.png,.gif,.mp4,.msg,.bmp,.jpeg"
            >
              <el-button size="mini" type="primary">Upload</el-button>
            </el-upload>
            <el-button size="mini" type="primary" plain style="margin-left:8px;" @click="handleDownloadTemplate">Download Template</el-button>
            <div class="modify-doc-att-file-info" v-if="modifyFileName">
              <a class="doc-upload-file-name" :title="modifyFileName">
                <i class="el-icon-document"></i>{{ modifyFileName }}
              </a>
              <label>
                <span class="doc-upload-percentage" v-if="uploadPercentage > 0 && uploadPercentage < 100">{{ uploadPercentage }}%</span>
                <i class="el-icon-circle-check" style="color: #67c23a" v-if="uploadPercentage === 100"></i>
                <i class="el-icon-close doc-upload-icon-close" @click="handleRemoveFile"></i>
              </label>
              <el-progress v-if="uploadPercentage > 0 && uploadPercentage < 100" :show-text="false" :stroke-width="2" :percentage="uploadPercentage"></el-progress>
            </div>
          </el-form-item>
          <el-form-item label="Period" prop="year" v-if="showPeriod">
            <el-date-picker v-model="modifyForm.year" type="year" value-format="yyyy" placeholder="Year" style="width:160px;margin-right:8px;" disabled></el-date-picker>
            <el-select v-if="showQuarter" v-model="modifyForm.quarter" placeholder="Quarter" clearable style="width:150px;" disabled>
              <el-option v-for="q in quarterOptions" :key="q" :label="q" :value="q"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="Quarter" prop="quarter" v-if="showQuarter" class="doc-quarter-hidden-label"></el-form-item>
          <el-form-item label="Remark">
            <el-input type="textarea" :rows="10" v-model="modifyForm.remark" placeholder="Please input remark" maxlength="500" show-word-limit></el-input>
          </el-form-item>
        </el-form>
        <div class="modify-doc-tips">
          <span class="modify-doc-tips-title">Tips:</span> Maximum Document Size: 50M; Format: docx, xlsx, pptx, png, jpeg, bmp, mp4, msg.
        </div>
      </div>

      <span slot="footer">
        <el-button size="small" @click="modifyVisible = false">Cancel</el-button>
        <el-button type="primary" size="small" :loading="modifyLoading" @click="saveModify">Save</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import axios from 'axios'
import moment from 'moment'
export default {
  name: 'documentManagement',
  created() {
    this.initDropdownData()
    this.handleSearch()
  },
  data() {
    return {
      moment,
      // Search form
      searchForm: {},
      // Dropdown options
      countryList: [],
      docTypeList: [],
      quarterOptions: ['Q1', 'Q2', 'Q3', 'Q4'],
      // Table
      tableData: [],
      tableLoading: false,
      currentPage: 1,
      pageSize: 10,
      totalCount: 0,
      // Sort
      sortField: '',
      sortOrder: '',
      // Modify dialog
      modifyVisible: false,
      modifyLoading: false,
      modifyForm: {
        fileId: '',
        year: null,
        quarter: '',
        remark: '',
      },
      modifyRules: {
        fileId: [
          { required: true, validator: this.validateFile, trigger: 'change' }
        ],
        year: [
          { required: true, message: 'Please select Year', trigger: 'change' }
        ],
        quarter: [
          { required: true, message: 'Please select Quarter', trigger: 'change' }
        ],
      },
      modifyFileName: '',
      modifyFile: null,
      uploadPercentage: 0,
      cancelUpload: null,
      // Uploaded By remote search
      uploadedBySearchList: [],
      searchTimeout: null,
    }
  },
  computed: {
    showPeriod() {
      return ['Account Profile', 'QBR', 'Visit Minutes'].includes(this.modifyForm.docType)
    },
    showQuarter() {
      return ['QBR', 'Visit Minutes'].includes(this.modifyForm.docType)
    }
  },
  methods: {
    initDropdownData() {
      // keyValue/queryLabelList: ValuedAccountDocType
      let kvUrl = `${this.$store.state.islhurl}keyValue/queryLabelList?keyList=ValuedAccountDocType`
      this._get(kvUrl).then(res => {
        if (res.code === 200 && res.data) {
          this.docTypeList = res.data.ValuedAccountDocType || []
        }
      }).catch(() => {})
      // lov/ipms/options: Country
      const lovCodes = 'HPFM.OVERSEA_COUNTRY'
      const lovUrl = `${this.$store.state.islhurl}lov/ipms/options?lovCodes=${encodeURIComponent(lovCodes)}`
      this._get(lovUrl).then(res => {
        if (res.code === 200 && res.data) {
          const sortByOrder = (arr) => (arr || []).sort((a, b) => (a.orderSeq || 0) - (b.orderSeq || 0))
          this.countryList = sortByOrder(res.data['HPFM.OVERSEA_COUNTRY'])
        }
      }).catch(() => {})
    },
    // User remote search
    filterUploadedBy(query) {
      if (query !== '') {
        if (this.searchTimeout) clearTimeout(this.searchTimeout)
        this.searchTimeout = setTimeout(() => {
          this.fetchUserOptions(query)
        }, 200)
      } else {
        this.uploadedBySearchList = []
      }
    },
    fetchUserOptions(query) {
      let url = `${this.$store.state.islhurl}user/select-option?keyword=${query}`
      this._get(url).then(res => {
        if (res.code === 200 && res.data) {
          this.uploadedBySearchList = res.data
        } else {
          this.uploadedBySearchList = []
        }
      }).catch(() => {
        this.uploadedBySearchList = []
      })
    },
    // Sort field mapping
    _mapSortField(prop) {
      const map = {
        accountName: 'accountName',
        country: 'country',
        docType: 'docType',
        periodDisplay: 'period',
        uploadTime: 'uploadTime',
        uploadedBy: 'uploadedBy',
        fileName: 'fileName',
        remark: 'remark',
      }
      return map[prop] || prop
    },
    handleSearch() {
      this.currentPage = 1
      this._doSearch()
    },
    _doSearch() {
      const values = this.searchForm
      let params = {
        pageNum: this.currentPage,
        pageSize: this.pageSize,
        country: values.country || undefined,
        accountName: values.accountName || undefined,
        docType: values.docType || undefined,
        uploadedBy: values.uploadedBy || undefined,
        periodStartYear: values.periodStartYear || undefined,
        periodStartQuarter: values.periodStartQuarter || undefined,
        periodEndYear: values.periodEndYear || undefined,
        periodEndQuarter: values.periodEndQuarter || undefined,
        gtsCode: values.gtsCode || undefined,
        uploadTimeStart: values.uploadTime ? moment(values.uploadTime[0]).format('YYYY-MM-DD') : undefined,
        uploadTimeEnd: values.uploadTime ? moment(values.uploadTime[1]).format('YYYY-MM-DD') : undefined,
        sortField: this.sortField ? this._mapSortField(this.sortField) : undefined,
        sortOrder: this.sortOrder === 'ascending' ? 'asc' : (this.sortOrder === 'descending' ? 'desc' : undefined),
      }
      Object.keys(params).forEach(key => {
        if (params[key] === undefined || params[key] === '') delete params[key]
      })

      this.tableLoading = true
      let url = `${this.$store.state.islhurl}valued-account/document/list`
      this.$axios.get(url, { params }).then(res => {
        this.tableLoading = false
        const data = res.data
        if (data.code === 200) {
          this.tableData = data.data || []
          this.totalCount = data.totalSize || 0
        } else {
          this.tableData = []
          this.totalCount = 0
          this.$message.error(data.msg || 'Failed!')
        }
      }).catch(() => {
        this.tableLoading = false
        this.tableData = []
        this.totalCount = 0
      })
    },
    changePageSize(size) {
      this.pageSize = size
      this.handleSearch()
    },
    changePage(current) {
      this.currentPage = current
      this._doSearch()
    },
    handleReset() {
      this.searchForm = {}
      this.uploadedBySearchList = []
      this.sortField = ''
      this.sortOrder = ''
      this.currentPage = 1
      this._doSearch()
    },
    handleSortChange({ prop, order }) {
      this.sortField = order ? (prop || '') : ''
      this.sortOrder = order || ''
      this._doSearch()
    },
    handleDetail(row) {
      this.$router.push({ name: 'accountDetail', params: { id: row.customerId }, query: { from: 'documentManagement' } })
    },
    _getFileNameFromResponse(response) {
      const disposition = response.headers && response.headers['content-disposition']
      if (disposition) {
        const match = disposition.match(/filename\*?=(?:UTF-8''|"?)([^";]+)/i)
        if (match && match[1]) {
          return decodeURIComponent(match[1].replace(/"/g, ''))
        }
      }
      return null
    },
    _downloadFile(fileId, fileName) {
      if (!fileId) {
        this.$message.warning('No file to download')
        return
      }
      let url = `${this.$store.state.islhurl}attachment/download/${fileId}`
      this.$axios({
        url,
        method: 'get',
        responseType: 'blob'
      }).then(response => {
        const blob = new Blob([response.data])
        const aEle = document.createElement('a')
        const href = window.URL.createObjectURL(blob)
        aEle.href = href
        aEle.download = this._getFileNameFromResponse(response) || fileName || 'document'
        document.body.appendChild(aEle)
        aEle.click()
        document.body.removeChild(aEle)
        window.URL.revokeObjectURL(href)
      }).catch(() => {
        this.$message.error('Download failed!')
      })
    },
    handleDocDownload(row) {
      if (!row.fileId) {
        this.$message.warning('No file to download')
        return
      }
      this._downloadFile(row.fileId, row.fileName)
    },
    handleDocModify(row) {
      this.modifyForm = {
        id: row.id,
        accountId: row.accountId,
        country: row.country,
        gtsCode: row.gtsCode || '',
        accountName: row.accountName,
        docType: row.docType,
        fileId: 'existing',
        year: null,
        quarter: '',
        remark: row.remark || '',
      }
      this.modifyFileName = row.fileName || ''
      this.modifyFile = null
      this.uploadPercentage = 0
      this.cancelUpload = null
      // Parse period from row
      if (row.periodYear) {
        this.modifyForm.year = row.periodYear
      }
      if (row.periodQuarter) {
        this.modifyForm.quarter = row.periodQuarter
      }
      this.modifyVisible = true
      this.$nextTick(() => {
        if (this.$refs.modifyForm) this.$refs.modifyForm.clearValidate()
      })
    },
    validateFile(rule, value, callback) {
      if (this.uploadPercentage > 0 && this.uploadPercentage < 100) {
        callback(new Error('Please wait for the upload to complete before saving.'))
      } else if (!value) {
        callback(new Error('Please upload an attachment.'))
      } else {
        callback()
      }
    },
    beforeUpload(file) {
      // if (this.modifyFileName) {
      //   this.$message.warning('Only one file is allowed for upload. The previous file will be replaced.')
      // }
      const isLt50M = file.size / 1024 / 1024 < 50
      if (!isLt50M) {
        this.$message.error('File cannot be larger than 50MB!')
        return false
      }
      return true
    },
    uploadFile(row) {
      if (typeof this.cancelUpload === 'function') {
        this.cancelUpload('Replaced by new upload')
        this.cancelUpload = null
      }
      const file = row.file
      let fd = new FormData()
      fd.append('file', file)
      fd.append('moduleType', 'VALUED_ACCOUNT')
      let url = `${this.$store.state.islhurl}attachment/upload`
      const CancelToken = axios.CancelToken
      const source = CancelToken.source()
      this.cancelUpload = source.cancel
      this.modifyFile = file
      this.modifyFileName = file.name
      this.modifyForm.fileId = ''
      this.uploadPercentage = 0
      this._post(url, fd, {
        cancelToken: source.token,
        onUploadProgress: (percent) => {
          this.uploadPercentage = percent === 100 ? 99 : percent
        },
        noProgress: true
      }).then(res => {
        if (res.code == 200) {
          this.uploadPercentage = 100
          this.modifyForm.fileId = res.data.id || res.data
          this.$refs.modifyForm.clearValidate('fileId')
        } else {
          this.modifyFileName = ''
          this.modifyFile = null
          this.modifyForm.fileId = ''
          this.uploadPercentage = 0
          this.$message.error(res.message || 'Upload failed!')
        }
      }).catch(error => {
        console.log(error)
        this.modifyFileName = ''
        this.modifyFile = null
        this.modifyForm.fileId = ''
        this.uploadPercentage = 0
      })
    },
    handleRemoveFile() {
      if (typeof this.cancelUpload === 'function') {
        this.cancelUpload('User canceled upload')
        this.cancelUpload = null
      }
      this.modifyFileName = ''
      this.modifyFile = null
      this.modifyForm.fileId = ''
      this.uploadPercentage = 0
    },
    handleDownloadTemplate() {
      const docType = this.modifyForm.docType
      if (!docType) return
      let url = `${this.$store.state.islhurl}valued-account/document/template?docType=${encodeURIComponent(docType)}`
      this.$axios({
        url,
        method: 'get',
        responseType: 'blob'
      }).then(response => {
        const blob = new Blob([response.data])
        const aEle = document.createElement('a')
        const href = window.URL.createObjectURL(blob)
        aEle.href = href
        aEle.download = this._getFileNameFromResponse(response) || (docType + '_Template')
        document.body.appendChild(aEle)
        aEle.click()
        document.body.removeChild(aEle)
        window.URL.revokeObjectURL(href)
      }).catch(() => {
        this.$message.error('Download template failed!')
      })
    },
    saveModify() {
      this.$refs.modifyForm.validate((valid) => {
        if (!valid) return
        this.modifyLoading = true

        const param = {}
        // fileId: if user uploaded new file, pass new fileId; otherwise don't pass (only update period/remark)
        if (this.modifyForm.fileId && this.modifyForm.fileId !== 'existing') {
          param.fileId = this.modifyForm.fileId
        }
        if (this.showPeriod && this.modifyForm.year) {
          param.periodYear = this.modifyForm.year
        }
        if (this.showQuarter && this.modifyForm.quarter) {
          param.periodQuarter = this.modifyForm.quarter
        }
        if (this.modifyForm.remark !== undefined) {
          param.remark = this.modifyForm.remark
        }

        let url = `${this.$store.state.islhurl}valued-account/document/${this.modifyForm.id}`
        this._put(url, param).then(res => {
          this.modifyLoading = false
          if (res.code === 200) {
            this.$message.success('Save successful!')
            this.modifyVisible = false
            this.handleSearch()
          } else {
            this.$message.error(res.message || 'Save failed!')
          }
        }).catch(() => {
          this.modifyLoading = false
          this.$message.error('Save failed!')
        })
      })
    },
  },
}
</script>

<style lang="less" scoped>
#documentManagement {
  .btn-col {
    padding: 30px 0 0 0px;
  }
  .el-form {
    padding: 20px 0 20px 0;
    .el-form-item {
      margin-bottom: 0px;
      padding: 0 15px 0 0;
    }
    /deep/.el-form-item__label {
      line-height: 22px;
      padding: 4px 12px 0px 0px;
    }
    /deep/.el-select {
      width: 100%;
    }
    /deep/.el-form-item__content .el-input__suffix {
      left: auto;
      right: 10px;
    }
    /deep/.el-range-editor.el-input__inner {
      width: 100%;
    }
  }
  .el-table {
    /deep/th.el-table__cell > .cell {
      word-break: break-word;
    }
  }
  /deep/.el-form-item__error {
    padding-top: 0;
  }
  /deep/.el-dialog__body {
    padding: 10px 20px;
    .el-form {
      padding: 0;
    }
  }

  // Modify dialog styles
  .modify-doc-info {
    margin-bottom: 20px;
  }
  .modify-doc-info-row {
    display: flex;
    gap: 24px;
    align-items: baseline;
    &:not(:first-child) { margin-top: 8px; }
  }
  .modify-doc-info-item {
    display: flex;
    align-items: baseline;
    gap: 6px;
  }
  .modify-doc-info-label {
    font-size: 13px;
    color: #8C8C8C;
    white-space: nowrap;
    flex-shrink: 0;
  }
  .modify-doc-info-value {
    font-size: 13px;
    color: #1F2937;
    min-width: 85px;
  }

  .modify-doc-attachment {
    border: 1px solid #E5E7EB;
    border-radius: 4px;
    padding: 16px;
    background: #FAFAFA;
  }
  .modify-doc-att-header {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-bottom: 12px;
    flex-wrap: nowrap;
    white-space: nowrap;
    overflow: hidden;
  }
  .modify-doc-att-name {
    font-size: 13px;
    color: #1F2937;
    font-weight: 500;
  }
  .modify-doc-att-colon {
    font-size: 13px;
    color: #1F2937;
  }
  .doc-upload-btn {
    display: inline-block;
  }
  .modify-doc-att-file-info {
    margin-top: 8px;
    border-radius: 4px;
    position: relative;
    line-height: 26px;
    &:hover {
      background-color: #f5f7fa;
      .el-icon-circle-check, .doc-upload-percentage {
        display: none;
      }
      .doc-upload-icon-close {
        display: inline-block !important;
      }
    }
  }
  .doc-upload-file-name {
    line-height: 26px;
    color: #606266;
    display: block;
    margin-right: 40px;
    overflow: hidden;
    padding-left: 4px;
    text-overflow: ellipsis;
    white-space: nowrap;
    cursor: pointer;
    &:hover {
      color: #409eff;
    }
    i {
      margin-right: 7px;
      color: #909399;
    }
  }
  .modify-doc-att-file-info label {
    position: absolute;
    right: 5px;
    top: 0;
    line-height: 26px;
    i {
      line-height: 26px;
    }
  }
  .doc-upload-percentage {
    color: #666;
    font-size: 12px;
  }
  .doc-upload-icon-close {
    cursor: pointer;
    display: none !important;
    color: #909399;
  }

  // Form styles inside the attachment area
  .modify-doc-attachment .el-form-item {
    margin-bottom: 18px;
  }
  .modify-doc-attachment .el-form-item__label {
    font-size: 12px;
    color: #8C8C8C;
  }
  .doc-quarter-hidden-label {
    margin-top: -18px;
    margin-bottom: 0 !important;
    /deep/ .el-form-item__label {
      visibility: hidden;
    }
    /deep/ .el-form-item__content {
      display: none;
    }
  }

  .modify-doc-tips {
    margin-top: 12px;
    font-size: 12px;
    // color: #8C8C8C;
    line-height: 1.8;
    color: #409eff;
  }
  .modify-doc-tips-title {
    font-size: 12px;
    color: #1F2937;
    font-weight: 500;
  }
}
</style>

<style>
.modify-doc-dialog .el-dialog__body {
  padding: 20px 24px;
}
.modify-doc-dialog .el-form-item--mini .el-form-item__error {
  padding-top: 3px;
}
</style>



// WEBPACK FOOTER //
// src/view/valuedAccountManagement/documentManagement.vue